import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ListItemAudioBookComponent } from './list-item-audio-book/list-item-audio-book.component';
import { PdpCommentComponent } from './pdp-comment/pdp-comment.component';
import { PdpComponent } from './pdp/pdp.component';


const routes: Routes = [
  {
    path: ':id',
    component: PdpComponent
  },
  {
    path: 'list/:id',
    component: ListItemAudioBookComponent
  },
  {
    path: ':id/:slug',
    redirectTo: ':id'
  },
  {
    path: 'comment/:audiobookId/:id',
    component: PdpCommentComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PDPRoutingModule { }
